import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

/**
 * 统一维护环境变量
 * 执行环境直接取 import.meta.env 默认值
 */
export const env = createEnv({
	clientPrefix: "VITE_",
	client: {
		VITE_API_HOST: z.string().min(1).optional(),
		VITE_CDN_HOST: z.string().min(1).optional(),
		VITE_TG_BOT_ID: z.string().min(1).optional(),
		VITE_SENTRY_DSN: z.string().min(1).optional(),
	},
	runtimeEnv: import.meta.env,
	emptyStringAsUndefined: true,
});
